<!--
 * @Author: 罗川平 2150673512@qq.com
 * @Date: 2022-07-16 11:12:40
 * @LastEditors: 罗川平 2150673512@qq.com
 * @LastEditTime: 2022-07-17 12:43:12
 * @FilePath: \manger\src\components\MyAside\MyAside.vue
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
-->
<template>
  <el-aside width="200px">
    <el-menu
      default-active="index"
      class="el-menu-vertical-demo"
      background-color="#282929"
      text-color="#fff"
      active-text-color="#ffd04b"
    >
      <router-link to="index"
        ><el-menu-item index="index">
          <i class="el-icon-menu"></i>
          <span slot="title">首页</span>
        </el-menu-item></router-link
      >
      <router-link to="neworder"
        ><el-menu-item index="neworder">
          <i class="el-icon-s-goods"></i>
          <span slot="title">最新交易</span>
        </el-menu-item></router-link
      >
      <router-link to="newarea">
        <el-menu-item index="newarea">
          <i class="el-icon-document"></i>
          <span slot="title">最新区块</span>
        </el-menu-item></router-link
      >
      <!-- <router-link to="user">
        <el-menu-item index="user">
          <i class="el-icon-setting"></i>
          <span slot="title">用户管理</span>
        </el-menu-item>
      </router-link>
      <router-link to="/swiper">
        <el-menu-item index="swiper">
          <i class="el-icon-setting"></i>
          <span slot="title">首页轮播</span>
        </el-menu-item>
      </router-link>
      <router-link to="admin">
        <el-menu-item index="admin">
          <i class="el-icon-s-custom"></i>
          <span slot="title">账号管理</span>
        </el-menu-item>
      </router-link> -->
    </el-menu>
  </el-aside>
</template>

<script>
export default {};
</script>

<style>
.el-aside {
  background-color: #282929;
  color: rgb(255, 255, 255);
}
</style>